module.exports = __webpack_public_path__ + "static/media/MelodyStern-resume.5f17e927.pdf";